export default __webpack_public_path__ + "static/sugamo-20190525-DSC03963-resize-w2000-db19b61a834025511b8264675888047c.jpg";